import { motion } from "framer-motion";
import { Reveal } from "@/components/site/Reveal";
import { MANIFESTO, IMAGES } from "@/lib/data";

export const Manifesto = () => (
  <section id="about" data-testid="manifesto-section" className="bg-bone py-28 lg:py-40">
    <div className="mx-auto max-w-[1400px] px-6 lg:px-12">
      <div className="grid lg:grid-cols-12 gap-16 items-start">
        {/* Sticky image */}
        <div className="lg:col-span-5">
          <div className="lg:sticky lg:top-28">
            <Reveal>
              <p className="mb-6 flex items-center gap-3 text-xs uppercase tracking-[0.3em] text-clay">
                <span className="h-[1px] w-10 bg-clay" /> Our philosophy
              </p>
              <h2 className="font-serif font-light text-4xl md:text-5xl leading-[1.05] tracking-tight text-[var(--astera-char)]">
                A clinic built around <span className="italic text-clay">how you actually feel.</span>
              </h2>
            </Reveal>
            <Reveal delay={0.15}>
              <div className="mt-10 aspect-square overflow-hidden rounded-[28px]">
                <img
                  src={IMAGES.about}
                  alt="A woman sitting calmly by warm window light"
                  className="h-full w-full object-cover"
                />
              </div>
            </Reveal>
          </div>
        </div>

        {/* Chapters */}
        <div className="lg:col-span-7 lg:pl-10">
          <div className="flex flex-col">
            {MANIFESTO.map((c, i) => (
              <Reveal key={c.n} delay={i * 0.08}>
                <div className="border-t border-[#EAE6E1] py-12 first:pt-0 first:border-t-0">
                  <div className="flex gap-8 items-start">
                    <span className="font-serif text-6xl md:text-7xl leading-none text-clay/25">
                      {c.n}
                    </span>
                    <div>
                      <h3 className="font-serif text-3xl md:text-4xl leading-tight text-[var(--astera-char)]">
                        {c.title}
                      </h3>
                      <p className="mt-5 text-[var(--astera-char)]/65 leading-relaxed max-w-xl">
                        {c.body}
                      </p>
                    </div>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </div>
  </section>
);
